import { companyPropertiesApi, systemPropertiesApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { selectIsMasterCompany } from 'store/auth/selectors';

export const COMPANY_PROPERTIES_ACTION_TYPE = createNamedActions('companyProperties', {
  GET_PROPERTIES: 'GET_PROPERTIES',
  GET_PROPERTY_DEFINITIONS: 'GET_PROPERTY_DEFINITIONS',
  ADD_PROPERTY: 'ADD_PROPERTY',
  REMOVE_PROPERTY: 'REMOVE_PROPERTY',
});

export const getPropertiesAction = catchAsyncActionError(params => async (dispatch, getState) => {
  const isMasterCompany = selectIsMasterCompany(params.companyId)(getState());

  const { data } = await (isMasterCompany
    ? systemPropertiesApi.getSystemProperties()
    : systemPropertiesApi.getSystemPropertiesInternal(params));

  return dispatch({
    type: COMPANY_PROPERTIES_ACTION_TYPE.GET_PROPERTIES,
    payload: data,
  });
});

export const getPropertyDefinitionsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await companyPropertiesApi.getCompanyPropertyDefinitions();

  return dispatch({
    type: COMPANY_PROPERTIES_ACTION_TYPE.GET_PROPERTY_DEFINITIONS,
    payload: data,
  });
});

export const savePropertyAction = catchAsyncActionError(params => async (dispatch, getState) => {
  const isMasterCompany = selectIsMasterCompany(params.companyId)(getState());

  const { data } = await (isMasterCompany
    ? systemPropertiesApi.createSystemProperties(params)
    : systemPropertiesApi.createSystemPropertiesInternal(params));

  return dispatch({
    type: COMPANY_PROPERTIES_ACTION_TYPE.ADD_PROPERTY,
    payload: data,
  });
});
